import { readonly } from 'vue';
import { IIncentiveV2State, IIncentiveV2Store, IIncentiveV2StoreDependencies } from '@/domain/dto/store.incentive-v2.interfaces';
import { createIncentiveV2State } from './state';
import { IncentiveV2Mutations } from './mutations';
import { IncentiveV2Getters } from './getters';
import { IncentiveV2Actions } from './actions';
import globals from '@/utils/globals';

/* Fresh store per mount, the isolation pattern proven by createIncentiveStore()/createFlowStore().
	Constructor-injects its own CaptchaService handle and the shared StudentAuthenticationService
	instance so no component needs to import globalStore. See docs/incentive-architecture.md
	sections 4.2/4.3. */
const createIncentiveV2Store = (dependencies: IIncentiveV2StoreDependencies): IIncentiveV2Store => {
	const state = createIncentiveV2State(dependencies);
	const mutations = new IncentiveV2Mutations(state);
	const getters = new IncentiveV2Getters(state);
	const captcha = globals.captchaService.createInstance();
	const actions = new IncentiveV2Actions(
		mutations,
		getters,
		captcha,
		globals.studentAuthenticationService,
		dependencies.steps,
		dependencies.onFinished,
	);

	return {
		state: readonly(state) as IIncentiveV2State,
		mutations,
		getters,
		actions,
		captcha,
	};
};

export { createIncentiveV2Store, createIncentiveV2Store as createIncentiveStore };
